// import { Component, Input, OnInit } from '@angular/core';
// import { DomSanitizer } from '@angular/platform-browser';
// import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// @Component({
// 	selector: 'file-view-modal',
// 	templateUrl: './file-view-modal.component.html',
// 	styleUrls: ['./file-view-modal.component.scss']
// })
// export class FileViewModalComponent implements OnInit {

// 	@Input() fileUrl: any;

// 	public url: any;
// 	public isLoading: boolean = true;

// 	constructor(public modal: NgbActiveModal,
// 		private sanitizer: DomSanitizer) { }

// 	ngOnInit() {

// 		this.isLoading = true;
//     if (this.fileUrl.split('.').pop() === 'html' || this.fileUrl.split('.').pop() === 'odt') {
//       this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
//     } else {
//       this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
//         `https://docs.google.com/viewer?url=${this.fileUrl}&embedded=true`
//       );
//     }

//     setTimeout(() => this.isLoading = false, 2500);
//   }

// }

import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { FileViewService } from '../../services/file-view.service';
import { HttpResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'file-view-modal',
    templateUrl: './file-view-modal.component.html',
    styleUrls: ['./file-view-modal.component.scss']
})
export class FileViewModalComponent implements OnInit {
	@Input() fileUrl: any;

	public url: any;
	public isLoading: boolean = true;
	public nopdf: boolean = false;
	/** Images render directly - no external viewer involved. */
	public isImage: boolean = false;
	public imageUrl: string = '';

	@ViewChild('iframeRef', { static: false }) iframeRef:
		| ElementRef
		| undefined;

	private checkIFrameSubscription: Subscription | undefined = undefined;
	private viewerUrl: string = '';
	private needsRetry: boolean = false;
	curl: any;

	constructor(
		public modal: NgbActiveModal,
		private sanitizer: DomSanitizer,
		private fileviewService:FileViewService,
		private toastr: ToastrService
	) {}


	ngOnInit() {
		this.isLoading = true;

		if (!this.fileUrl) {
		  this.toastr.error('This file could not be loaded. Please try again.');
		  this.isLoading = false;
		  return;
		}

		const lowerUrl = this.fileUrl.toLowerCase();
		const isResume = lowerUrl.includes('/resumes/');
		const isOffer = lowerUrl.includes('/offers/');
		const isPdf = lowerUrl.endsWith('.pdf');

		const isOfficeDoc = /\.(docx?|xlsx?|pptx?)$/i.test(lowerUrl);
		// strip any query string before testing the extension
		const path = lowerUrl.split('?')[0];
		const isImageFile = /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(path);

		// Images went to the Google Docs Viewer, which does not render them
		// reliably - it is a document viewer. Show them directly instead.
		if (isImageFile) {
			this.isImage = true;
			this.imageUrl = this.fileUrl;
			this.nopdf = false;
			this.isLoading = false;
			return;
		}

		// A PDF is a PDF wherever it lives - render it natively in an iframe.
		//
		// ng2-pdf-viewer fetches the file over XHR and needs a pdf.worker bundle.
		// Neither holds here: the CDN sends no CORS header for localhost, so the
		// fetch fails outright in dev, and no worker is configured in this project.
		// An iframe is a subresource load, so it needs no CORS and no worker, and
		// every current browser renders PDFs natively.
		if (path.endsWith('.pdf') && !isResume) {
			this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
			this.nopdf = true;
			this.needsRetry = false;
			this.isLoading = false;
			return;
		}

		if (isResume) {
		  // Always use PDF viewer for resumes
		  this.transformUrl(this.fileUrl);
		} else if (isOffer) {
		  if (isPdf) {
			// native iframe, as above
			this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
			this.nopdf = true;
			this.needsRetry = false;
			this.isLoading = false;
		  } else if (isOfficeDoc) {
			// Office Online Viewer for DOCX/XLSX/PPTX offers
			this.viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.fileUrl)}`;
			this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.viewerUrl);
			this.nopdf = true;
			this.needsRetry = false;
			this.isLoading = false;
		  } else {
			// Google Docs Viewer for other non-PDF offers
			this.viewerUrl = `https://docs.google.com/viewer?url=${this.fileUrl}&embedded=true`;
			this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.viewerUrl);
			this.nopdf = true;
			this.needsRetry = true;
			this.isLoading = false;
		  }
		} else if (isOfficeDoc) {
		  // Microsoft Office Online Viewer for DOCX/DOC/XLSX/PPTX message attachments
		  this.viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.fileUrl)}`;
		  this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.viewerUrl);
		  this.nopdf = true;
		  this.needsRetry = false;
		  this.isLoading = false;
		} else {
		  // Fallback - use Google Docs Viewer
		  this.viewerUrl = `https://docs.google.com/viewer?url=${this.fileUrl}&embedded=true`;
		  this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.viewerUrl);
		  this.nopdf = true;
		  this.needsRetry = true;
		  this.isLoading = false;
		}
	  }
	  /** A broken image should say so rather than showing an empty modal. */
	  onImageError() {
		this.isImage = false;
		this.toastr.error('This image could not be loaded.');
		this.modal.dismiss();
	  }

	  ngAfterViewInit() {
		// Only retry for Google Docs Viewer (Office Online loads reliably)
		if (!this.nopdf || !this.needsRetry) return;

		let iframe = this.iframeRef?.nativeElement || null;
		this.checkIFrame(iframe);

		this.checkIFrameSubscription = interval(3000)
		  .pipe(take(Math.round(20000 / 3000)))
		  .subscribe(() => {
			if (!iframe) {
			  iframe = this.iframeRef?.nativeElement || null;
			  this.checkIFrame(iframe);
			}

			this.reloadIFrame(iframe);
		  });
	  }

	  checkIFrame(iframe: any) {
		if (iframe) {
		  iframe.onload = () => {
			if (this.checkIFrameSubscription) {
			  this.checkIFrameSubscription.unsubscribe();
			}
		  };
		}
	  }

	  reloadIFrame(iframe: any) {
		if (iframe && this.viewerUrl) {
		  this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.viewerUrl);
		}
	  }


	transformUrl(url: string) {



		this.fileviewService.convertFiletopdf(this.fileUrl).subscribe(
			(res: HttpResponse<string>) => {
			  // Logs the full response, including headers and status
			  if (res.status === 200) {
				// Logs the actual plain text response
				const transformedUrl = url.replace('/resumes/', '/watermark/').replace(/\.docx?|\.txt|\.rtf|\.odt|\.html|\.pdf$/i, '.pdf');
				// native iframe for the same reason as above
				this.url = this.sanitizer.bypassSecurityTrustResourceUrl(transformedUrl);
				this.nopdf = true;
				this.needsRetry = false;
				this.isLoading = false;
			  }
			  else{
				this.isLoading = false;
			  }
			  this.isLoading = false;
			},
			(error) => {
			  this.toastr.error(error?.error?.Message || error?.message || 'An unexpected error occurred. Please try again.');
			  this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
			  this.isLoading = false;
			  this.nopdf=true
			}
		  );



	  }

	// ngOnInit() {
	// 	this.isLoading = true;
	// 	if (
	// 		this.fileUrl.split('.').pop() === 'html' ||
	// 		this.fileUrl.split('.').pop() === 'odt'
	// 	) {
	// 		this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
	// 			this.fileUrl
	// 		);
	// 	} else {
	// 		this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
	// 			`https://docs.google.com/viewer?url=${this.fileUrl}&embedded=true`
	// 		);
	// 	}

	// 	setTimeout(() => (this.isLoading = false), 2500);
	// }

	// checkIFrame(iframe: any) {
	// 	if (iframe) {
	// 		iframe.onload = () => {
	// 			if (this.checkIFrameSubscription) {
	// 				this.checkIFrameSubscription.unsubscribe();
	// 			}
	// 		};
	// 	}
	// }
	// reloadIFrame(iframe: any) {
	// 	if (iframe) {
	// 		// iframe.src = this.url;
	// 		if (
	// 			this.fileUrl.split('.').pop() === 'html' ||
	// 			this.fileUrl.split('.').pop() === 'odt'
	// 		) {
	// 			this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
	// 				this.fileUrl
	// 			);
	// 		} else {
	// 			this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
	// 				`https://docs.google.com/viewer?url=${this.fileUrl}&embedded=true`
	// 			);
	// 		}
	// 	}
	// }

// 	ngAfterViewInit() {
// 		let iframe = this.iframeRef ? this.iframeRef.nativeElement : null;

// 		this.checkIFrame(iframe);

// 		this.checkIFrameSubscription = interval(3000)
// 			.pipe(take(Math.round(20000 / 3000)))

// 			.subscribe(() => {
// 				if (iframe == null) {
// 					iframe = this.iframeRef
// 						? this.iframeRef.nativeElement
// 						: null;

// 					this.checkIFrame(iframe);
// 				}

// 				this.reloadIFrame(iframe);
// 			});
// 	}
// }


}
